export default __webpack_public_path__ + "static/media/mask6.92a4d663.jpg";